import { useState, type ReactNode } from 'react';
import { LinkButton, List } from './styles';

/**
 * Список с обрезкой: первые `limit` пунктов, остальные — по кнопке «ещё N»
 * (пакет бывает в сотни файлов — длинный список не должен вытеснять действия).
 */
export function MoreList<T>({
  items,
  render,
  itemKey,
  limit = 10,
}: {
  items: T[];
  render: (item: T) => ReactNode;
  itemKey: (item: T, index: number) => string;
  limit?: number;
}) {
  const [expanded, setExpanded] = useState(false);
  if (items.length === 0) return null;
  const shown = expanded ? items : items.slice(0, limit);
  const rest = items.length - shown.length;
  return (
    <List>
      {shown.map((item, i) => (
        <li key={itemKey(item, i)}>{render(item)}</li>
      ))}
      {rest > 0 ? (
        <li>
          <LinkButton type="button" onClick={() => setExpanded(true)}>
            ещё {rest}
          </LinkButton>
        </li>
      ) : null}
    </List>
  );
}

/** Список текстовых замечаний (предупреждения сбора файлов и т. п.). */
export function NoteList({ items, limit }: { items: string[]; limit?: number }) {
  return <MoreList items={items} limit={limit} itemKey={(w, i) => `${i}:${w}`} render={(w) => w} />;
}
